import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React from 'react';
import {Carousel} from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import {getFullImageUrl} from '../../../common/utils/image';
import {StackParams} from '../../../data/types/navigation';
import {Loader} from '../Loader';
import {listDefaultItem} from './defaultCarouselOfflline';
import './style.web.css';

type Props = {
  listItem: never[];
};

type NavigationProps = StackNavigationProp<StackParams, 'Home'>;
export default ({listItem}: Props) => {
  const {navigate} = useNavigation<NavigationProps>();

  const carousel =
    listItem && listItem.length > 0
      ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        listItem.map((item: any) => {
          const {imageUrl, nom, description} = item;
          return (
            <div
              key={nom}
              onClick={() =>
                navigate('Details', {
                  id: item.id,
                  isCatalogue: item.type === 'catalogue',
                  nom: item.nom,
                })
              }
              className="carouselWeb"
              style={{
                backgroundImage: `url(${getFullImageUrl(imageUrl)})`,
              }}>
              <img src={getFullImageUrl(imageUrl)} />
              <div className="legends">
                <h2 className="legend-title">{nom}</h2>
                <p className="legend-paragraphe">
                  {description && description}
                </p>
              </div>
            </div>
          );
        })
      : listDefaultItem.map((item: {nom: string; description: string}) => {
          const {nom, description} = item;
          return (
            <div key={nom}>
              <Loader />
              <div className="legends">
                <h2 className="legend-title">{nom}</h2>
                <p className="legend-paragraphe">
                  {description && description}
                </p>
              </div>
            </div>
          );
        });
  return (
    <div className="container-fluid welcome">
      {listItem && listItem.length > 0 ? (
        <Carousel swipeable infiniteLoop interval={4000} autoPlay={true}>
          {carousel}
        </Carousel>
      ) : (
        <Loader />
      )}
    </div>
  );
};
